import { Component, OnInit }            from '@angular/core';
import { Router }                       from '@angular/router';
import { AuthService }                  from '../../../providers/auth.service';
import { Role }                         from '../../models/role';
import { RoleService }                  from '../../services/role.service';
import { RoleEditComponent }            from '.././role-edit/role-edit.component';
import { Subject }                      from 'rxjs/Subject';

@Component({
  selector: 'role-list',
  templateUrl: 'role-list.component.html',
  styleUrls: ["role-list.component.scss"]
})

export class RoleLitsComponent implements OnInit {
    selectedRole: Role;
    roles: Role[];
    private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private roleService: RoleService,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.authService.getUser().subscribe(user => {
      if(!user) {
        this.router.navigate(["/login"])
      }
    })
    this.roleService.getRoles()
     .subscribe(roles => this.roles = roles);
  }

  delete(e, role: Role)
  {
    e.stopPropagation();
    this.roleService.delete(role).subscribe(error => {console.log(error); this.refresh()});
  }

  refresh() {
    window.location.reload();
  }

  onSelect(role: Role):void {
    this.selectedRole = role;
  }
}



// WEBPACK FOOTER //
// ./src/app/users/components/role-list/role-list.component.ts